module.exports = __webpack_public_path__ + "media/images/logos/paypal-972799ca0e348fccb5ca29cbfcdf4c9c.svg";